export default __webpack_public_path__ + "static/media/top-round-image.ec4c6d15.png";